import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import uuidv4 from "../../../helpers/uuid";
import { Skeleton } from "@material-ui/lab";

type ReportSimpleTableProps = {
  header: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rows: any[][];
  loading?: boolean;
  customHeight?: string;
};

const loadingState = new Array(12).fill({});

function ReportSimpleTable({
  header,
  rows,
  loading = false,
  // eslint-disable-next-line react/prop-types
  customHeight = "100%",
}: ReportSimpleTableProps) {
  const [useId] = React.useState(uuidv4());

  return (
    <TableContainer style={{ height: customHeight }} component={Paper}>
      <Table stickyHeader style={{ width: "100%" }}>
        <TableHead style={{ backgroundColor: "lightgrey", textAlign: "left" }}>
          <TableRow>
            {header.map(
              (h, idx) =>
                h != "" ?? (
                  <TableCell align="left" key={`${useId}_header_${idx}`}>
                    <strong>{h}</strong>
                  </TableCell>
                )
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {!loading &&
            rows.map((row, idx) => (
              <TableRow key={`${useId}_row_${idx}`}>
                {row.map((cell, idy) => (
                  <TableCell align="center" key={`${useId}_row_${idx}_col_${idy}`}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          {loading &&
            loadingState.map((_, idx) => (
              <TableRow key={`${useId}_loading_row_${idx}`}>
                <TableCell colSpan={header.length}>
                  <Skeleton />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ReportSimpleTable;
